import React, { useState, useEffect } from 'react';
import { FiPhone, FiMessageCircle, FiX } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useData } from '../contexts/DataContext';

const FloatingCTA = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isMinimized, setIsMinimized] = useState(false);

  // Get settings data
  const { settings } = useData();

  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling 300px
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!isVisible) return null;

  return (
    <>
      {/* 
        NOTE: The previous mobile fixed bottom bar has been removed 
        to accommodate the new glassy MobileAppFooter navigation.
      */}

      {/* Desktop Floating Widget - Kept for larger screens */}
      <div className="hidden lg:block fixed bottom-6 right-6 z-50">
        {!isMinimized ? (
          <div className="bg-white rounded-2xl shadow-2xl border border-emerald-100 p-6 max-w-sm">
            <div className="flex justify-between items-start mb-4">
              <div>
                <h3 className="font-bold text-gray-900 text-lg">Need Help?</h3>
                <p className="text-gray-600 text-sm">Get instant support</p>
              </div>
              <button 
                onClick={() => setIsMinimized(true)}
                className="text-gray-400 hover:text-gray-600 transition-colors"
              >
                <SafeIcon icon={FiX} className="w-5 h-5" />
              </button>
            </div>
            
            <div className="space-y-3">
              <a href={`tel:${settings.contact_phone || settings.phone1 || '9581556660'}`} className="flex items-center space-x-3 bg-emerald-50 hover:bg-emerald-100 p-3 rounded-xl transition-colors">
                <div className="w-10 h-10 bg-emerald-600 rounded-full flex items-center justify-center">
                  <SafeIcon icon={FiPhone} className="w-5 h-5 text-white" />
                </div>
                <div>
                  <div className="font-semibold text-gray-900">Call Now</div>
                  <div className="text-sm text-gray-600">{settings.contact_phone || settings.phone1 || '9581556660'}</div>
                </div>
              </a>
              
              <a href={`https://wa.me/${settings.whatsapp || settings.phone1 || '919581556660'}`} className="flex items-center space-x-3 bg-green-50 hover:bg-green-100 p-3 rounded-xl transition-colors">
                <div className="w-10 h-10 bg-green-500 rounded-full flex items-center justify-center">
                  <SafeIcon icon={FiMessageCircle} className="w-5 h-5 text-white" />
                </div>
                <div>
                  <div className="font-semibold text-gray-900">WhatsApp</div>
                  <div className="text-sm text-gray-600">Chat with our team</div>
                </div>
              </a>
            </div>
          </div>
        ) : (
          <button 
            onClick={() => setIsMinimized(false)}
            className="bg-emerald-600 hover:bg-emerald-700 text-white w-14 h-14 rounded-full shadow-2xl flex items-center justify-center transition-all duration-300 hover:scale-110"
          >
            <SafeIcon icon={FiPhone} className="w-6 h-6" />
          </button>
        )}
      </div>
    </>
  );
};

export default FloatingCTA;